import script from "./ScopeBusiness.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopeBusiness.vue?vue&type=script&setup=true&lang=js"

import "./ScopeBusiness.vue?vue&type=style&index=0&id=53dbd94c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53dbd94c"]])

export default __exports__